import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance } from '../json/JsonReader.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  falseVariables32gd1w4dsf9iv as falseVariables,
  parseData1xjh6qzzvft3n as parseData,
} from '../Executables.mjs';
import { readAny17j2jqaxubdko as readAny } from '../json/JsonReaders.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder16nv925388a0q as Builder } from '../ApolloResponse.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Error3q6zoyx198bpg as Error_0,
  Location25t453jk43ktl as Location,
} from '../Error.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readErrors(_this__u8e3s4) {
  if (_this__u8e3s4.u40().equals(Token_NULL_getInstance())) {
    _this__u8e3s4.n4a();
    return emptyList();
  }
  _this__u8e3s4.w41();
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().p2();
  while (_this__u8e3s4.q1()) {
    list.i2(readError(_this__u8e3s4));
  }
  _this__u8e3s4.x41();
  return list;
}
var ResponseParserClass;
function ResponseParser() {
  if (ResponseParserClass === VOID) {
    class $ {
      u47(jsonReader, operation, requestUuid, customScalarAdapters, deferredFragmentIds) {
        jsonReader.r41();
        var data = null;
        var errors = null;
        var extensions = null;
        while (jsonReader.q1()) {
          switch (jsonReader.t41()) {
            case 'data':
              var falseVariables_0 = falseVariables(operation, customScalarAdapters);
              data = parseData(operation, jsonReader, customScalarAdapters, falseVariables_0, deferredFragmentIds, errors);
              break;
            case 'errors':
              errors = readErrors(jsonReader);
              break;
            case 'extensions':
              var tmp = readAny(jsonReader);
              extensions = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : null;
              break;
            default:
              jsonReader.t40();
              break;
          }
        }
        jsonReader.s41();
        return Builder().s44(operation, requestUuid == null ? uuid4() : requestUuid).w44(errors).v44(data).y44(extensions).d38();
      }
    }
    initMetadataForObject($, 'ResponseParser');
    ResponseParserClass = $;
  }
  return ResponseParserClass;
}
var ResponseParser_instance;
function ResponseParser_getInstance() {
  return ResponseParser_instance;
}
function readError(_this__u8e3s4) {
  var message = '';
  var locations = null;
  var path = null;
  var extensions = null;
  var nonStandardFields = null;
  _this__u8e3s4.r41();
  while (_this__u8e3s4.q1()) {
    var name = _this__u8e3s4.t41();
    switch (name) {
      case 'message':
        var tmp0_elvis_lhs = _this__u8e3s4.b42();
        message = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        break;
      case 'locations':
        locations = readErrorLocations(_this__u8e3s4);
        break;
      case 'path':
        path = readPath(_this__u8e3s4);
        break;
      case 'extensions':
        var tmp = readAny(_this__u8e3s4);
        extensions = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : null;
        break;
      default:
        if (nonStandardFields == null) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          nonStandardFields = LinkedHashMap().bc();
        }

        var tmp0 = nonStandardFields;
        // Inline function 'kotlin.collections.set' call

        var value = readAny(_this__u8e3s4);
        tmp0.x4(name, value);
        break;
    }
  }
  _this__u8e3s4.s41();
  return new (Error_0())(message, locations, path, extensions, nonStandardFields);
}
function readErrorLocations(_this__u8e3s4) {
  if (_this__u8e3s4.u40().equals(Token_NULL_getInstance())) {
    return _this__u8e3s4.n4a();
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().p2();
  _this__u8e3s4.w41();
  while (_this__u8e3s4.q1()) {
    list.i2(readErrorLocation(_this__u8e3s4));
  }
  _this__u8e3s4.x41();
  return list;
}
function readPath(_this__u8e3s4) {
  if (_this__u8e3s4.u40().equals(Token_NULL_getInstance())) {
    return _this__u8e3s4.n4a();
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList().p2();
  _this__u8e3s4.w41();
  while (_this__u8e3s4.q1()) {
    switch (_this__u8e3s4.u40().w1_1) {
      case 6:
      case 7:
        list.i2(_this__u8e3s4.kk());
        break;
      default:
        list.i2(ensureNotNull(_this__u8e3s4.b42()));
        break;
    }
  }
  _this__u8e3s4.x41();
  return list;
}
function readErrorLocation(_this__u8e3s4) {
  var line = -1;
  var column = -1;
  _this__u8e3s4.r41();
  while (_this__u8e3s4.q1()) {
    switch (_this__u8e3s4.t41()) {
      case 'line':
        line = _this__u8e3s4.kk();
        break;
      case 'column':
        column = _this__u8e3s4.kk();
        break;
      default:
        _this__u8e3s4.t40();
        break;
    }
  }
  _this__u8e3s4.s41();
  return new (Location())(line, column);
}
//region block: init
ResponseParser_instance = new (ResponseParser())();
//endregion
//region block: exports
export {
  readErrors as readErrors1y0wtxnlur21l,
  ResponseParser_instance as ResponseParser_instancefop6qlssmux5,
};
//endregion

//# sourceMappingURL=ResponseParser.mjs.map
